import { PaginationReq } from "./pagenation.req.dto";

export class PaginatedResponse {
    pagination: PaginationReq
    paginatedData: any;

    constructor(
        pagination: PaginationReq,
        paginatedData: any,
    ) {
        this.pagination = pagination
        this.paginatedData = paginatedData
    }
}